import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToLocalDate } from "../../../utils/dateConvert";
import { downloadCSVFile } from "../../../api/apiClient";

function ExceptionTable(props) {
  let assetName= props.assetCustomerName;
  let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';
  const data = (
    <React.Fragment>
      <h5 className="exceptionThe blue">{`Sensor A Threshold: ${props.thresholdA}`}</h5>
      <h5 className="exceptionThe lightRed">{`Sensor B Threshold: ${props.thresholdB}`}</h5>
      <Table responsive striped>
        <thead>
          <tr className="nowwrapTH">
            <th>Exception ID</th>
            <th>Type</th>
            <th>Started</th>
            <th>Completed</th>
            <th>Duration</th>
            <th>Trip ID(trigger)</th>
            <th>Sensor A (Trigger)</th>
            <th>Sensor B (Trigger)</th>
            <th>Fridge On (Trigger)</th>
            <th>Sensor A (End) </th>
            <th>Sensor B (End) </th>
            <th>Fridge On (End)</th>
          </tr>
        </thead>
        <tbody>
          {props.exceptionTable.map((exception, index) => {
            return (
              <tr>
                <td>{index + 1}</td>
                <td>{exception.type}</td>
                <td>{utcToLocalDate(exception.started)}</td>
                <td>{utcToLocalDate(exception.completed)}</td>
                <td>{exception.duration}</td>
                <td>n/a</td>
                <td>{exception.tempAStart}</td>
                <td>{exception.tempBStart}</td>
                <td>{exception.fridgeStart ? "on" : "off"}</td>
                <td>{exception.tempAEnd}</td>
                <td>{exception.tempBEnd}</td>
                <td>{exception.fridgeEnd ? "on" : "off"}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </React.Fragment>
  );
  const handleDownloadExcel = () => {
    // alert("clicked")
    downloadCSVFile(props.exceptionTable,"TempEx",assetName,timeZone);
  };
  return (
    <ToggleBar
      caption="Exceptions"
      icon="fa fa-thermometer-full"
      color="#A94442"
      content={data}
      download={handleDownloadExcel}
    />
  );
}

export default ExceptionTable;
